import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import BarraNavegacion from "Componentes/BarraNavegacion";
import DashBoard from "DashBoard/DashBoard";
import Login from "Login/Login";

const rutasProtegidas = [
  {
    base: "Albaranestaller",
    listado: lazy(() => import("Taller/AlbaranesTaller/Listado")),
    nuevo: lazy(() => import("Taller/AlbaranesTaller/Nuevo")),
    edicion: lazy(() => import("Taller/AlbaranesTaller/Edicion")),
  },
  {
    base: "Articulos",
    listado: lazy(() => import("Maestros/Articulos/Listado")),
    nuevo: lazy(() => import("Maestros/Articulos/Nuevo")),
    edicion: lazy(() => import("Maestros/Articulos/Edicion")),
  },
  {
    base: "Clientes",
    listado: lazy(() => import("Maestros/Clientes/Listado")),
    nuevo: lazy(() => import("Maestros/Clientes/Nuevo")),
    edicion: lazy(() => import("Maestros/Clientes/Edicion")),
  },
  {
    base: "Viajes",
    listado: lazy(() => import("Viajes/Listado")),
    nuevo: lazy(() => import("Viajes/Nuevo")),
    edicion: lazy(() => import("Viajes/Edicion")),
  },
  {
    base: "ComprasTaller",
    listado: lazy(() => import("Taller/ComprasTaller/Listado")),
    nuevo: lazy(() => import("Taller/ComprasTaller/Nuevo")),
    edicion: lazy(() => import("Taller/ComprasTaller/Edicion")),
  },
  {
    base: "Configuracion",
    listado: lazy(() => import("Maestros/Configuracion/Configuracion")),
  },
  {
    base: "Cuotas",
    listado: lazy(() => import("Taller/Cuotas/Cuotas")),
  },
  {
    base: "FacturacionTaller",
    listado: lazy(() => import("Taller/FacturacionTaller/FacturacionTaller")),
  },
  {
    base: "FacturasTaller",
    listado: lazy(() => import("Taller/FacturasTaller/Listado")),
    edicion: lazy(() => import("Taller/FacturasTaller/Edicion")),
  },
  {
    base: "FormasDePago",
    listado: lazy(() => import("Maestros/FormasDePago/Listado")),
    nuevo: lazy(() => import("Maestros/FormasDePago/Nuevo")),
    edicion: lazy(() => import("Maestros/FormasDePago/Edicion")),
  },
  {
    base: "Impuestos",
    listado: lazy(() => import("Maestros/Impuestos/Listado")),
    nuevo: lazy(() => import("Maestros/Impuestos/Nuevo")),
    edicion: lazy(() => import("Maestros/Impuestos/Edicion")),
  },
  {
    base: "Proveedores",
    listado: lazy(() => import("Maestros/Proveedores/Listado")),
    nuevo: lazy(() => import("Maestros/Proveedores/Nuevo")),
    edicion: lazy(() => import("Maestros/Proveedores/Edicion")),
  },
  {
    base: "Series",
    listado: lazy(() => import("Maestros/Series/Listado")),
    nuevo: lazy(() => import("Maestros/Series/Nuevo")),
    edicion: lazy(() => import("Maestros/Series/Edicion")),
  },
  {
    base: "Socios",
    listado: lazy(() => import("Maestros/Socios/Listado")),
    nuevo: lazy(() => import("Maestros/Socios/Nuevo")),
    edicion: lazy(() => import("Maestros/Socios/Edicion")),
  },
];

const ProtectedRoute = ({ children }) => {

  const token = localStorage.getItem("tokenIntranetCocantra");

  const handleLogout = () => {
    localStorage.removeItem("tokenIntranetCocantra");
    window.location.href = "/login";
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <BarraNavegacion onLogout={handleLogout} />
      <div style={{ marginTop: "20px" }}>{children}</div>
    </>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Ruta principal protegida */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashBoard />
            </ProtectedRoute>
          }
        />

        {/* Rutas protegidas generadas dinámicamente */}
        {rutasProtegidas.map(({ base, listado, nuevo, edicion, editarCabecera }) => (
          <React.Fragment key={base}>
            <Route
              path={`/${base}`}
              element={
                <ProtectedRoute>{React.createElement(listado)}</ProtectedRoute>
              }
            />
            <Route
              path={`/${base}/Nuevo`}
              element={
                <ProtectedRoute>{React.createElement(nuevo)}</ProtectedRoute>
              }
            />
            <Route
              path={`/${base}/Editar/:id`}
              element={
                <ProtectedRoute>{React.createElement(edicion)}</ProtectedRoute>
              }
            />
            {editarCabecera && (
              <Route
                path={`/${base}/EditarCabecera/:id`}
                element={
                  <ProtectedRoute>{React.createElement(editarCabecera)}</ProtectedRoute>
                }
              />
            )}


          </React.Fragment>
        ))}
      </Routes>
    </Router>
  );
};

export default AppRoutes;